import { render, staticRenderFns } from "./AddEditDriver.vue?vue&type=template&id=c5ec58dc&scoped=true&"
import script from "./AddEditDriver.vue?vue&type=script&lang=js&"
export * from "./AddEditDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ec58dc",
  null
  
)

export default component.exports